import { render, staticRenderFns } from "./positiondetails.vue?vue&type=template&id=6c4e967e&scoped=true"
import script from "./positiondetails.vue?vue&type=script&lang=js"
export * from "./positiondetails.vue?vue&type=script&lang=js"
import style0 from "./positiondetails.vue?vue&type=style&index=0&id=6c4e967e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4e967e",
  null
  
)

export default component.exports